import React, { useContext, useEffect, useState } from "react";
import { Songs } from "../Context"; //import biến songs

export default function ListSongs() {

  const { DataSongs, handleSetSong, song } = useContext(Songs); //sử dụng hook use-context lấy giữ liệu từ context songs


  const [idSong, setidSong] = useState(0); // idsong = 0

  const handlePlaySong = (idSong) => { //khi cllick vào bài hát thì nó chạy
    
    setidSong(idSong) //idsong = CLick
    handleSetSong(idSong)  // ??????????????????????????
  };


  useEffect(() => {
    setidSong(song.id) //idsong = cái này là cái j ?
  }, [song])


  return (
    <div className="col-span-2  overflow-y-scroll">
      <table className="table-auto w-full">
        <thead className="text-white h-12">
          <tr>
            <th className="w-[10%]">#</th>
            <th className="text-left">Title</th>
            <th className="w-[10%]">Author</th>
            <th className="w-[10%]">
              <i className="fa fa-download"></i>
            </th>
          </tr>
        </thead>

        <tbody>

          {DataSongs.map((song, index) => // song -> là giá trị phần tử mảng , index là vị trí phần tử mảng
          
          (  
            <tr
              key={index}   //index = 0 
              className={`bg-slate-800 h-12 text-gray-500 hover:bg-slate-600 ${idSong === song.id && 'bg-slate-600 text-teal-400'}`}
              onClick={() => handlePlaySong(song.id)} //truyền vào song.id = 
            >

              <td className="text-center">{index + 1}</td>

              <td>{song.name}</td> //
              <td className="text-center">{song.author}</td>
             
              <td className="text-center">
                <a href={song.url}>
                  <i className="fa fa-download"></i>
                </a>
              </td>
            </tr>
          )
          )
          }

          
          {/* {for (let index = 0; index < DataSongs.length; index++) {
  const song = DataSongs[index];
  return (
    <tr
      key={index}
      className={`bg-slate-800 h-12 text-gray-500 hover:bg-slate-600 ${idSong === song.id && 'bg-slate-600 text-teal-400'}`}
      onClick={() => handlePlaySong(song.id)}
    >

      <td className="text-center">{index + 1}</td>

      <td>{song.name}</td>
      <td className="text-center">{song.author}</td>
     
      <td className="text-center">
        <a href={song.url}>
          <i className="fa fa-download"></i>
        </a>
      </td>
    </tr>
  );
}} */}


        </tbody>
      </table>
    </div>
  );
}
